module.exports = __webpack_public_path__ + "static/media/d13eb061-c936-4f75-ae5d-8e68fc67e3ec.35030eb9.JPG";